export default __webpack_public_path__ + "images/DR.567d568.png";